import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../../components/_table/TableFilterInput';
import TableFilterSelect from '../../../../../components/_table/TableFilterSelect';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import Anchor from '../../../../../components/link/Anchor';
import { PRODUCT_STATUS_TEXT } from '../../../../../constants/service/app/productConstants';
import { setNumberWithComma, addAllItemToSelectList } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  추천 상품에 연결된 상품 아이템 리스트 컬럼
 */
export const columns = (data) => {
  const {
    isFilter,
    filterOption,
    sortOption,
    onFilter,
    mainProductCategorySelectList = [],
    subProductCategorySelectList = { [null]: [] },
    getProductSubCategoryList,
  } = data;
  const targetParentId = filterOption && filterOption.mainCategory ? filterOption.mainCategory : null;
  const filteredMainCategoryName =
    filterOption &&
    filterOption.mainCategory &&
    mainProductCategorySelectList.find((item) => item.id === filterOption.mainCategory).name;
  const filteredSubCategoryName =
    filterOption &&
    filterOption.mainCategory &&
    filterOption.subCategory &&
    subProductCategorySelectList[filterOption.mainCategory].find((item) => item.id === filterOption.subCategory).name;

  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'url',
      render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
    },
    {
      title: <TableColumnTitle title={'브랜드명'} filterValue={filterOption.brandName} />,
      dataIndex: 'storeName',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'브랜드명 검색'}
          option={filterOption.brandName}
          confirm={confirm}
          onFilter={(brandName) => onFilter({ brandName })}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'브랜드 ID'} filterValue={filterOption.storeId} />,
      dataIndex: 'storeId',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'브랜드 ID 검색'}
          option={filterOption.storeId}
          confirm={confirm}
          onFilter={(storeId) => onFilter({ storeId })}
        />
      ),
      render: (value) => <OpenBrandDetail text={value} storeId={value} />,
    },
    {
      title: <TableColumnTitle title={'상품 번호'} filterValue={filterOption.productId} />,
      dataIndex: 'id',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'상품 번호 검색'}
          option={filterOption.productId}
          confirm={confirm}
          onFilter={(productId) => onFilter({ productId })}
        />
      ),
      render: (value) => <OpenProductDetail text={value} productId={value} />,
    },
    {
      title: <TableColumnTitle title={'1차 카테고리'} filterValue={filteredMainCategoryName} />,
      dataIndex: 'mainCategory',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterSelect
          list={addAllItemToSelectList(mainProductCategorySelectList)}
          option={filterOption.mainCategory}
          confirm={confirm}
          onFilter={(mainCategory) =>
            onFilter({
              mainCategory,
              subCategory: null,
            })
          }
        />
      ),
    },
    {
      title: <TableColumnTitle title={'2차 카테고리'} filterValue={filteredSubCategoryName} />,
      dataIndex: 'isSubCategoryExists',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterSelect
          list={addAllItemToSelectList(subProductCategorySelectList[targetParentId])}
          option={filterOption.subCategory}
          confirm={confirm}
          onFilter={(subCategory) => onFilter({ subCategory })}
        />
      ),
      render: (value, record) =>
        value ? (
          <Anchor
            text="카테고리 보기"
            isUnderLine
            color="primary"
            onClick={() =>
              getProductSubCategoryList({
                productId: record.id,
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      title: <TableColumnTitle title={'상태'} />,
      dataIndex: 'status',
      render: (value) => PRODUCT_STATUS_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'상품명'} filterValue={filterOption.productName} />,
      dataIndex: 'productName',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'상품명 검색'}
          option={filterOption.productName}
          confirm={confirm}
          onFilter={(productName) => onFilter({ productName })}
        />
      ),
      render: (value, record) => <OpenPreviewProductDetail text={value} productId={record.id} />,
    },
    {
      title: <TableColumnTitle title={'판매가 (원)'} />,
      dataIndex: 'originPrice',
      sorter: isFilter,
      sortOrder: sortOption['originPrice'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'할인가 (원)'} />,
      dataIndex: 'discountPrice',
      sorter: isFilter,
      sortOrder: sortOption['discountPrice'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'할인율 (%)'} />,
      dataIndex: 'discountRate',
      sorter: isFilter,
      sortOrder: sortOption['discountRate'],
    },
    {
      title: <TableColumnTitle title={'할인기간'} />,
      dataIndex: 'discountPeriod',
    },
    {
      title: <TableColumnTitle title={'실판매가 (원)'} />,
      dataIndex: 'salesPrice',
      sorter: isFilter,
      sortOrder: sortOption['salesPrice'],
      render: (value) => setNumberWithComma(value),
    },
    {
      title: <TableColumnTitle title={'등록일'} />,
      dataIndex: 'createDate',
      sorter: isFilter,
      sortOrder: sortOption['createDate'],
      render: (value) => setDateFormat(value),
    },
  ];
};
